<template>
    <v-dialog
    v-model="show"
    persistent
    width="920">
   
    <v-card color="light_gray">
        <v-toolbar class="mid-font" dense>
            <v-icon left >mdi-archive-search</v-icon><span class="va-underline">Product Finder</span>
            <v-spacer/>
            
            <v-btn small @click="emitToParent()" color="success">Done</v-btn>
          </v-toolbar>
          <v-card-text class="pa-4 def-font">

            <div class="pa-2">
                <v-text-field
                v-model="search"
                label="Search Product"
                outlined
                hide-details
                append-icon="mdi-archive-search"
                ></v-text-field>
            </div>
            <v-divider class="mt-4 mb-4"/>
               <table class="va-table va-table-border-bot">
                  <tr>
                    <th width="40"></th>
                    <th width="100"></th>
                    <th>Product Name</th>
                    <th>Properties</th>
                    <th>In-Stock</th>
                    <th>Status</th>
                    <th class="text-right">Sales Price</th>
                  </tr>
                  <tr v-for="(item, index) in SEARCHFILTER" :key="index+'-l'">
                    <td class="text-center">
                        <v-checkbox
                        v-model="item.checked"
                        @change="onChecked(item)"/>
                    </td>
                    <td>  <img :src="ImagePreview(item.images)" width="90%"/></td>
                    <td>{{ item.name }}
                        <br/><span class="font-italic sm-font" v-if="item.code!='null'">CODE: {{ item.code }}</span>
                    </td>
                    <td>
                        <p class="ma-1" v-for="(_prop, _index) in item.properties" :key="_index+'-p'">{{_prop.name}} : {{_prop.value}} </p>
                    </td>
                    <td>{{ item.stock }}</td>
                    <td><v-chip small :color="STATUS_COLOR(item.status)">{{ item.status }}</v-chip></td>
                    <td class="text-right">{{ $money(item.selling_price )}}</td>
                  </tr>
                  
                </table>  
   
          </v-card-text>
          <v-card-actions>
                 <v-btn @click="emitToParent()"  block>Done</v-btn>
              <v-spacer/>
             
          </v-card-actions>
    </v-card>
  
  </v-dialog>
</template>

<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
export default {
    mixins: [API_MIXINS],
  props: {
      show:{
          type: Boolean,
          default: false
      },
      state: {
          type: String,
          default: 'new'
      },

  },
  data () {
      return {
        valid: true,
        search: "",
        items: [],
        selected:[]
      }
    },
  watch: {
    show(v){
        if(v){
            this.search=''
            
            this.getItems()
        } else {
          this.selected = []
        }
    }
  },
  computed:{
     SEARCHFILTER(){
            if(this.search != "") {
              return this.$crawler(this.items, this.search)
            } else {
              return this.items
            }
         }
  },
  methods: {
    onChecked(val){
      if(val.checked) {
        this.selected.push(val)
      } else {
        console.log("unchecked")
      }
      
    },
   emitToParent () {
    console.log("selected", this.selected)
    if(this.selected == null) {
      this.$emit('DialogEvent', 'close')
      return
    }
    if(this.selected.length>0) {
         this.$emit('DialogEvent', this.selected)
         return
    } else {
         this.$emit('DialogEvent', 'close')
         return
    }
     
    },
     getItems() { 
          this.items = []
            this.QUERY('sales',"select p.name, p.code,p.track, p.description, p.images, p.tags, 1 as quantity, i.selling_price as amount, i.*, FALSE as checked from product_items i left join products p on p.id=i.product_id where p.status='Available' order by p.id desc", (res)=>{
              this.items = res.results
              console.log(this.items)
            })
        }
  }
}
</script>
